import type { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'

export type Badge = Awaited<
  ReturnType<typeof MembershipsBadgesApiClient.getBadges>
>['data']['badges'][number]

export type TableData = Badge & {
  additionalBadges?: Badge[]
}

export enum FormFields {
  uncollapsedBadgesCount = 'uncollapsedBadgesCount',
}

export type FormValues = {
  [FormFields.uncollapsedBadgesCount]: string
}
